import { FieldValues, UseFormRegister } from 'react-hook-form';

import Input from '../../../components/form/Input';
import { IConfigItemType } from '../validates/sectionBuilderSchema';

import RenderObjectLabel from './RenderObjectLabel';

export interface IPropsPintoCustomLinkItem {
  type: IConfigItemType.PintoCustomLink;
  link: string;
  deeplink: string;
}

interface IPropsPintoCustomLinkSectionItem {
  index: number;
  itemData?: IPropsPintoCustomLinkItem;

  register: UseFormRegister<FieldValues>;
  isShowOptionalFields?: boolean;
  expanded?: boolean;
}

const PintoCustomLinkSectionItem = (props: IPropsPintoCustomLinkSectionItem) => {
  const { index, itemData, register, expanded } = props;

  return (
    <div className="flex justify-between space-x-16">
      <div className="w-full collapse">
        <input type="checkbox" className="peer" defaultChecked={expanded} />
        <div className=" collapse-title bg-systemGrays08FillQuaternary text-systemGrays01LabelPrimary peer-checked:bg-systemGrays08FillQuaternary peer-checked:text-systemGrays01LabelPrimary flex justify-between after:content-['+'] peer-checked:after:content-['-'] ease-out duration-300">
          <span>
            <span>Custom Link </span>
            <RenderObjectLabel
              objectLists={[
                { key: 'link', value: itemData?.link, required: true },
                { key: 'deeplink', value: itemData?.deeplink, required: true },
              ]}
            />
          </span>
        </div>

        <div className="collapse-content text-systemGrays01LabelPrimary peer-checked:bg-systemGrays08FillQuaternary peer-checked:text-systemGrays01LabelPrimary">
          <div className="space-y-8">
            <Input label="link" name="link" helperText="Input Link" placeholder="link" register={() => register(`configItems.${index}.link`)} required />
            <Input
              label="deeplink"
              name="deeplink"
              helperText="Input deeplink"
              placeholder="pinto://campaign?id=hbd"
              register={() => register(`configItems.${index}.deeplink`)}
              required
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PintoCustomLinkSectionItem;
